import React from "react";
import classnames from "classnames";
import CircularProgress from "@mui/material/CircularProgress";
import useStyles from "./FmLoader.style";

interface FmLoaderProps {
    variant?: "primary" | "secondary" | "info";
    size?: "verySmall" | "small" | "big";
    className?: string;
    fullScreenCover?: boolean;
}

const FmLoader = ({ className, fullScreenCover = false, variant = "primary", size = "small" }: FmLoaderProps) => {
    const classes = useStyles();
    const loaderClass = !fullScreenCover ? className : undefined;
    const containerClass = fullScreenCover ? classnames(classes.fullScreenContainer, className) : undefined;

    const renderLoader = () => (
        <CircularProgress className={loaderClass} color={variant} size={size === "verySmall" ? "2rem" : size === "small" ? "3rem" : "5rem"} />
    );

    return fullScreenCover ? <div className={containerClass}>{renderLoader()}</div> : <>{renderLoader()}</>;
};

export default FmLoader;
